export type Theme = "light" | "dark";

const KEY = "sercamp-qa-theme";

/** Lê o tema salvo (ou a preferência do sistema operacional). */
export function getInitialTheme(): Theme {
  const saved = localStorage.getItem(KEY);
  if (saved === "light" || saved === "dark") return saved;
  const prefersDark =
    window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
}

/** Aplica o tema no <html> e persiste a escolha. */
export function applyTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(KEY, theme);
}
